import {alpha} from '@mui/material/styles';

// ----------------------------------------------------------------------

// SETUP COLORS

const GREY = {
  0: '#FFFFFF',
  100: '#F9FAFB',
  200: '#F4F6F8',
  300: '#DFE3E8',
  400: '#C4CDD5',
  500: '#919EAB',
  600: '#637381',
  700: '#454F5B',
  800: '#212B36',
  900: '#161C24',
};

const PRIMARY = {
  lighter: '#C8FAD6',
  light: '#5BE49B',
  main: '#00A76F',
  dark: '#007867',
  darker: '#004B50',
  contrastText: '#FFFFFF',
};

const SECONDARY = {
  lighter: '#EFD6FF',
  light: '#C684FF',
  main: '#DC362E',
  dark: '#5119B7',
  darker: '#27097A',
  contrastText: '#FFFFFF',
};

const INFO = {
  lighter: '#CAFDF5',
  light: '#61F3F3',
  main: '#E8ECF1',
  dark: '#006C9C',
  darker: '#003768',
  contrastText: '#454F5B',
};

const SUCCESS = {
  lighter: '#D3FCD2',
  light: '#77ED8B',
  main: '#EAF4EA',
  dark: '#118D57',
  darker: '#065E49',
  contrastText: '#48813F',
};

const WARNING = {
  lighter: '#FFF5CC',
  light: '#FFD666',
  main: '#F6F0D9', // '#FFAB00',
  dark: '#B76E00',
  darker: '#7A4100',
  contrastText: '#A98D31' //GREY[800],
};

const ERROR = {
  lighter: '#B3261E',
  light: '#FFAC82',
  main: '#B3261E',
  dark: '#B71D18',
  darker: '#FFFFFF',
  contrastText: '#FFFFFF',
};

const ERRORLIGHT = {
  lighter: 'blue',
  light: '#48813F',
  main: '#FCEEEE',
  dark: 'gray',
  darker: 'black',
  contrastText: '#B3261E',
};

const COMMON = {
  common: {
    black: '#000000',
    white: '#FFFFFF',
  },
  primary: PRIMARY,
  secondary: SECONDARY,
  info: INFO,
  success: SUCCESS,
  warning: WARNING,
  error: ERROR,
  errorLight: ERRORLIGHT,
  grey: GREY,
  divider: alpha(GREY[500], 0.2),
  action: {
    hover: alpha(GREY[500], 0.08),
    selected: alpha(GREY[500], 0.16),
    disabled: alpha(GREY[500], 0.8),
    disabledBackground: alpha(GREY[500], 0.24), //'#E8ECF1',//
    focus: alpha(GREY[500], 0.24),
    hoverOpacity: 0.08,
    disabledOpacity: 0.48,
  },
};

export function palette(mode) {
  const light = {
    ...COMMON,
    mode: 'light',
    text: {
      primary: "#212B36",
      secondary: GREY[600],
      disabled: GREY[500],
      tertiary: "#637381",
    },
    background: {
      paper: '#FFFFFF',
      default: '#FFFFFF',
      neutral: GREY[200],
    },
    action: {
      ...COMMON.action,
      active: GREY[600],
    },
  };

  const dark = {
    ...COMMON,
    mode: 'dark',
    text: {
      primary: '#FFFFFF',
      secondary: GREY[500],
      disabled: GREY[600],
    },
    background: {
      paper: GREY[800],
      default: GREY[900],
      neutral: alpha(GREY[500], 0.12),
    },
    action: {
      ...COMMON.action,
      active: GREY[500],
    },
  };

  return mode === 'light' ? light : dark;
}
